import { Menu, Transition } from "@headlessui/react";
import { FaUser } from "react-icons/fa";
import React from "react";
import Link from "next/link";
import useStore, { StoreState } from "../../context/useStore";

interface AuthProp {}

const Auth: React.FC<AuthProp> = () => {
  const setDialog = useStore((state: StoreState) => state.setDialog);
  const auth = useStore((state: StoreState) => state.auth);
  const setAuth = useStore((state: StoreState) => state.setAuth);
  const setProperties = useStore((state: StoreState) => state.setProperties);

  return (
    <>
      {auth.login === true ? (
        <>
          <div className="z-50">
            <Menu as="div">
              <Menu.Button>
                <div className="bg-primary p-2 mix-blend-screen rounded-full cursor-pointer relative">
                  <FaUser />
                </div>
              </Menu.Button>
              <Transition
                as={React.Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
              >
                <Menu.Items className="absolute w-32 mr-5 bg-white rounded-sm right-0 border border-black border-opacity-5 text-black z-50">
                  <div className="p-2 border-b border-b-black border-opacity-5">
                    <h4 className="font-normal">{auth?.name}</h4>
                    <p className="font-extralight italic break-all">
                      {auth?.email}
                    </p>
                  </div>

                  <Menu.Item>
                    <>
                      <Link href="/profile">
                        <p
                          aria-label="Profile"
                          title="Profile"
                          className="p-2 hover:bg-gray-100 duration-200 cursor-pointer"
                        >
                          Profile
                        </p>
                      </Link>
                    </>
                  </Menu.Item>
                  <span className="border-b border-b-black border-opacity-10"></span>
                  <Menu.Item>
                    <>
                      <p
                        onClick={() => {
                          localStorage.removeItem("token");
                          setAuth({
                            login: false,
                            verify: false,
                          });
                          setProperties([]);
                        }}
                        aria-label="Logout"
                        title="Logout"
                        className="p-2 hover:bg-gray-100 duration-200 cursor-pointer"
                      >
                        Logout
                      </p>
                    </>
                  </Menu.Item>
                </Menu.Items>
              </Transition>
            </Menu>
          </div>
        </>
      ) : (
        <>
          <div>
            <button
              onClick={() => {
                setDialog({
                  open: true,
                  closable: true,
                });
              }}
              className="bg-primary rounded-md mix-blend-screen px-7 py-1.5 md:py-2"
            >
              Login
            </button>
          </div>
        </>
      )}
    </>
  );
};

export default Auth;
